import { ThemeEvents } from '@theme/events';
const key = 'madamcase-phone-model-v1';
const normalize = value => String(value || '').trim().replace(/\s+/g, ' ');
const valid = value => /^iPhone\s+\d{2}(?:\s+(?:Pro Max|Pro|Plus|Air))?$/i.test(value);
const root = () => window.Shopify?.routes?.root || '/';
let toastTimer;
function read() {
  try { const saved = JSON.parse(localStorage.getItem(key)); return saved && Date.now() - saved.time < 30 * 86400000 && valid(saved.model) ? saved.model : ''; } catch { return ''; }
}
function save(model) {
  model = normalize(model);
  if (!valid(model)) return;
  try { localStorage.setItem(key, JSON.stringify({ model, time: Date.now() })); } catch {}
  renderMemory(model);
}
function modelLink(model) {
  const slug = model.toLowerCase().replace(/\s+/g, '-') + '-kiliflari';
  const links = [...document.querySelectorAll('a[href]')];
  const found = links.find(a => { try { return new URL(a.href).pathname.endsWith('/collections/' + slug); } catch { return false; } });
  return found?.href || root() + 'search?type=product&q=' + encodeURIComponent(model);
}
function renderMemory(model) {
  let bar = document.querySelector('.mc-model-memory');
  if (!bar) {
    const main = document.querySelector('#MainContent');
    if (!main) return;
    bar = document.createElement('div');bar.className = 'mc-model-memory';
    const link = document.createElement('a');link.dataset.modelLink = '';
    const change = document.createElement('button');change.type='button';change.textContent='Modeli değiştir';
    const select = document.createElement('select');select.hidden=true;select.setAttribute('aria-label','Telefon modelini değiştir');
    const models = new Set([model]);
    document.querySelectorAll('.mpc-phone-menu a').forEach(a=>{const v=normalize(a.textContent);if(valid(v))models.add(v)});
    models.forEach(v=>{const o=document.createElement('option');o.value=v;o.textContent=v;select.append(o)});
    select.addEventListener('change',()=>{save(select.value);select.hidden=true;change.hidden=false});
    change.addEventListener('click',()=>{select.hidden=false;change.hidden=true;select.focus()});
    bar.append(link,change,select);main.prepend(bar);
  }
  const link=bar.querySelector('[data-model-link]');link.textContent=model+' için keşfet ♡';link.href=modelLink(model);
  const select=bar.querySelector('select');
  if(![...select.options].some(o=>o.value===model)){const o=document.createElement('option');o.value=model;o.textContent=model;select.append(o)}
  select.value=model;
}
function optionsValue(options, name) {
  return options?.find(o => name.test(o.name))?.value || '';
}
document.addEventListener(ThemeEvents.variantUpdate,event=>{
  const picker=event.target.closest?.('variant-picker');
  const index=Number(picker?.dataset.mcModelIndex ?? -1);
  if(index>=0)save(event.detail?.resource?.options?.[index]);
});
document.addEventListener('filter:update',event=>{
  const params=event.detail?.queryParams;
  if(params)for(const [name,value] of params)if(name.includes('option.model'))save(value);
});
document.addEventListener(ThemeEvents.cartUpdate,event=>{
  if(event.detail?.data?.didError)return;
  const source=event.detail?.data?.source;
  if(!['product-form-component','madam-cart-offer'].includes(source))return;
  const items=event.detail?.resource?.items || [];
  const item=items.find(i=>String(i.variant_id||i.id)===String(event.detail?.sourceId)) || (source==='madam-cart-offer'?items[0]:null);
  const model=optionsValue(item?.options_with_values,/^(model|telefon modeli|phone model)$/i);
  const color=optionsValue(item?.options_with_values,/^(renk|color|colour)$/i);
  if(model)save(model);
  let toast=document.querySelector('.mc-added-toast');
  if(!toast){toast=document.createElement('div');toast.className='mc-added-toast';toast.setAttribute('role','status');toast.setAttribute('aria-live','polite')}
  (document.querySelector('dialog[open]')||document.body).append(toast);
  toast.textContent=color?color+' çok yakıştı ♡ Sepetine eklendi.':'Güzel bir seçim ♡ Sepetine eklendi.';
  toast.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.hidden=true,2600);
});
const saved=read();if(saved)renderMemory(saved);
